import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";
import DateRange from "../../common/dateRange";
import * as R from "ramda";
import Api from "../../../../../Services/Api";
import { HttpStatus, Status } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import M from "moment";

class TabKwitansiBatalFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      documentOptions: [],
    }
  }

  async componentDidMount() {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const kasOptions = [];
    const documentOptions = [];
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllMasterKas({
        paramFilters: {
          kodecabang: this.props.kodeCabang,
          status: Status.ACTIVE,
        },
      }),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "DOCUMENT_TYPE",
          status: Status.ACTIVE,
        },
      })
    ]);

    responses.forEach((response, idx) => {
      if (idx === 0) {
        if (response.data.status === HttpStatus.SUCCESS) {
          kasOptions.push(
            ...response.data.data.map((d) => mapToObjectDDL(d.kodeKas, d.kodeKas))
          );
        }
      } else if (idx === 1) {
        if (response.data.status === HttpStatus.SUCCESS) {
          documentOptions.push(...response.data.data.map((d) => mapToObjectDDL(d.value, d.key)));
        }
      }
    });

    this.setState((prevValue) => ({
      ...prevValue,
      kasOptions,
      documentOptions,
      loading: false,
    }));
  }

  getDataValue(fieldName) {
    return !R.isNil(this.props.data) && this.props.data[fieldName]
      ? this.props.data[fieldName]
      : null;
  }

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <SimpleDDL
              id="filter"
              box="search"
              name="paymentType"
              placeholder="ALL/BKM/BKK"
              options={[
                { value: null, label: "ALL" },
                { value: "IN", label: "BKM" },
                { value: "OUT", label: "BKK" },
              ]}
              value={this.getDataValue("paymentType")}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <DateRange
              label="Tanggal BKM/BKK"
              startDateName="startBkkBkmDate"
              endDateName="endBkkBkmDate"
              data={this.props.data}
              onStartDateChange={(name, value) =>
                this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
              onEndDateChange={(name, value) =>
                this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleInput
              id="input_text_nomor_bkm"
              name="paymentCashId"
              label="Nomor BKM/BKK"
              value={this.getDataValue("paymentCashId")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleDDL
              id="select_options_jenis_dokumen"
              name="keyDocumentType"
              label="Jenis Dokumen"
              box="search"
              options={this.state.documentOptions}
              value={this.getDataValue("keyDocumentType")}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <SimpleInput
              id="input_text_no_doc_ref1"
              name="documentRef1No"
              label="Nomor Dokument Ref 1"
              value={this.getDataValue("documentRef1No")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <DateRange
              label="Tanggal Dokumen Ref 1"
              startDateName="startDocumentRef1Date"
              endDateName="endDocumentRef1Date"
              data={this.props.data}
              onStartDateChange={(name, value) =>
                this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
              onEndDateChange={(name, value) =>
                this.props.onValueChange(name, M(value).format("DD-MM-YYYY"))
              }
            />
            <SimpleDDL
              id="select_options_kode_kas"
              name="kodeKas"
              label="Kode Kas"
              box="search"
              options={this.state.kasOptions}
              value={this.getDataValue("kodeKas")}
              onChange={(value, { name }) => this.props.onValueChange(name, value)}
            />
            <SimpleInput
              id="input_text_terima_dari"
              name="transactionPersonName"
              label="Terima Dari/Bayar Kepada"
              value={this.getDataValue("transactionPersonName")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleTextArea
              id="input_text_guna_membayar"
              name="paymentPurpose"
              typeInputCase="normal"
              label="Guna Membayar"
              value={this.getDataValue("paymentPurpose")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <SimpleTextArea
              id="input_text_keterangan"
              name="note"
              typeInputCase="normal"
              label="Keterangan"
              value={this.getDataValue("note")}
              onChange={({ target }) => this.props.onValueChange(target.name, target.value)}
            />
            <div style={{ textAlign: "center" }}>
              <SimpleButton secondary onClick={this.props.onClear}>
                Hapus
              </SimpleButton>
              <SimpleButton onClick={this.props.onSubmit}>Terapkan</SimpleButton>
            </div>
          </ModalContainer>
        }
      />
    );
  }
}

export default TabKwitansiBatalFilter;
